module.exports = __webpack_public_path__ + "img/coins.2ae3a134.svg";